import { isDebug } from '@/utils/debug';
import { isInAppWebView } from '@/utils/appBridge';
import { getCookie } from '@/utils/cookies';

// Readable cookie admin2 (lb-admin-api) sets on its own domain when an admin
// logs in. It only decides whether the developer menu's button shows; every
// admin action is still checked by admin2 itself.
export const DEV_MENU_COOKIE = 'lb-dev-menu';

// The developer menu (src/components/DevMenu) shows on local, PR preview and
// release hosts, and on production only for admins. Never in relocasa-app's
// WebViews.
export function isDevMenuEnabled() {
  if (isInAppWebView()) return false;

  return isDebug() || getCookie(DEV_MENU_COOKIE) === '1';
}
